import React from "react";

export const MorningIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M3.87255 17.4243H1.93652M6.11265 11.9202L4.74367 10.5513M17.1206 11.9202L18.4896 10.5513M21.2968 17.4243H19.3608M6.77659 17.4243C6.77659 14.7512 8.94356 12.5842 11.6167 12.5842C14.2898 12.5842 16.4567 14.7512 16.4567 17.4243M21.2968 21.2963H1.93652M15.4887 5.80809L11.6167 1.93604M11.6167 1.93604L7.7446 5.80809M11.6167 1.93604V8.71213"
      strokeWidth="1.93603"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
